module.exports = __webpack_public_path__ + "static/media/dynamic_segments_sparkle_color.a7d23d64.svg";